import React from 'react';
import { ListFieldSection, SectionGroup, FieldSet, PageSection } from '../../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../../Core/InjectedPropsContext';
import { Checkbox, Field, TextOutput, Label } from '../../../../../Core';
import AtterbergLimitChartSection from '../../../Shared/ChartSection';
import {
  IWithWorksheetInjectedProps,
  WorksheetBalanceFieldSet,
  WorksheetEquipmentDropdown,
} from 'Components/Worksheets/Core';
import {
  LiquidLimitEquipmentDetailsSection,
  LiquidLimitMethodATrialSection,
} from 'Components/Worksheets/AtterbergLimitWorksheet/Aashto/Sections';
import { useSelector } from 'react-redux';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';

let LiquidLimitMethodAPageSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  return (
    <PageSection heading="Liquid Limit">
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <LiquidLimitEquipmentDetailsSection />
        <SectionGroup heading="Liquid Limit Determination">
          <ListFieldSection>
            <FieldSet>
              <Label>Material Suitability</Label>
              <Field input={<Checkbox />} label="Result cannot be obtained" name="NonPlastic" />
            </FieldSet>
          </ListFieldSection>
          {determinationPerformed && (
            <>
              <ListFieldSection>
                <WorksheetBalanceFieldSet label="Balance" name="Balance" />
                <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Oven" />
                <WorksheetBalanceFieldSet label="Dry Mass Balance" name="DryMassBalance" />
              </ListFieldSection>
              <LiquidLimitMethodATrialSection />
            </>
          )}
        </SectionGroup>
      </NamePrefixModifier>
      <SectionGroup heading="Result">
        <NamePrefixModifier namePrefix="flowChart">
          <AtterbergLimitChartSection visible={determinationPerformed} />
        </NamePrefixModifier>
        <ListFieldSection>
          <Field input={<TextOutput />} label="Liquid Limit" name="Results.LiquidLimitText" />
        </ListFieldSection>
      </SectionGroup>
    </PageSection>
  );
};

LiquidLimitMethodAPageSection = withInjectedProps(LiquidLimitMethodAPageSection);

export { LiquidLimitMethodAPageSection };
export default LiquidLimitMethodAPageSection;
